import routes from "routes"

export const startCpatAssessment = ({
  attemptId,
  isProctored,
}: {
  attemptId: string
  isProctored: boolean
}) => {
  const url =
    routes.cpat.attempt.replace(":attemptId", attemptId) +
    (isProctored ? "?p=true" : "")
  window.location.href = url
}
